import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';

import { IExplorableItemTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { EditFlowAnalyticsExtensionConnection } from '../actions/EditFlowAnalyticsExtensionConnectionAction';
import { isFlowAnalyticsExtensionRow } from '../models/FlowAnalyticsExtensionRow';
import { handleEditFlowConnectionAction } from './EditFlowConnectionSaga';

export function getFlowConnectionAvailableActions(item: IExplorableItemTypeInfo): null | undefined {
  // Flow metadata supplies canUpdate; Analytics Extensions have no datasource ID.
  return isFlowAnalyticsExtensionRow(item) ? null : undefined;
}

export function* rootFlowConnectionSaga(): SagaIterator {
  yield takeEvery(EditFlowAnalyticsExtensionConnection, handleEditFlowConnectionAction);
}
